/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function FaceMask(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M208,136c0,50.95006-66.22217,68.789-78.16566,71.59207a8.00537,8.00537,0,0,1-3.66868,0C114.22217,204.789,48,186.95006,48,136V77.41626a8,8,0,0,1,5.02887-7.42781l72-28.8a8,8,0,0,1,5.94226,0l72,28.8A8,8,0,0,1,208,77.41626Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={88}
        y1={108}
        x2={168}
        y2={108}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Line
        x1={88}
        y1={144}
        x2={168}
        y2={144}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M205.40982,152H220a24,24,0,0,0,24-24V104a24,24,0,0,0-24-24H208"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M50.59121,152H36a24,24,0,0,1-24-24V104A24,24,0,0,1,36,80H48"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default FaceMask;
